module.exports = __webpack_public_path__ + "static/media/summer.66d39243.png";